import { ChevronLeft, ChevronRight } from 'lucide-react'
import React from 'react'

export default function NavButton({
  direction,
  onClick,
  disabled,
}: {
  direction: 'prev' | 'next'
  onClick: () => void
  disabled: boolean
}) {
  const isPrev = direction === 'prev'

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={isPrev ? 'Previous idea' : 'Next idea'}
      className={[
        'h-10 w-10 rounded-full',
        'bg-white border-2 border-black',
        'flex items-center justify-center text-[#1A1A1A]',
        'transition-all duration-200 ease-in-out',
        disabled ? '' : 'hover:shadow-md hover:bg-[#D4D4D4]',
        'shadow-sm',
      ].join(' ')}
    >
      {isPrev ? <ChevronLeft size={18} strokeWidth={2} /> : <ChevronRight size={18} strokeWidth={2} />}
    </button>
  )
}
